/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteAIConfigVariationRequest = {
  projectKey: string;
  configKey: string;
  variationKey: string;
};

/** @internal */
export const DeleteAIConfigVariationRequest$inboundSchema: z.ZodType<
  DeleteAIConfigVariationRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  projectKey: z.string(),
  configKey: z.string(),
  variationKey: z.string(),
});
/** @internal */
export type DeleteAIConfigVariationRequest$Outbound = {
  projectKey: string;
  configKey: string;
  variationKey: string;
};

/** @internal */
export const DeleteAIConfigVariationRequest$outboundSchema: z.ZodType<
  DeleteAIConfigVariationRequest$Outbound,
  z.ZodTypeDef,
  DeleteAIConfigVariationRequest
> = z.object({
  projectKey: z.string(),
  configKey: z.string(),
  variationKey: z.string(),
});

export function deleteAIConfigVariationRequestToJSON(
  deleteAIConfigVariationRequest: DeleteAIConfigVariationRequest,
): string {
  return JSON.stringify(
    DeleteAIConfigVariationRequest$outboundSchema.parse(
      deleteAIConfigVariationRequest,
    ),
  );
}
export function deleteAIConfigVariationRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteAIConfigVariationRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteAIConfigVariationRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteAIConfigVariationRequest' from JSON`,
  );
}
